import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const Navigation = () => {
    const location = useLocation();

    const isActive = (path) => {
        if (path === "/projects") {
            return location.pathname.startsWith("/projects");
        }
        return location.pathname === path;
    };

    useEffect(() => {
        // Function to dynamically load a script
        const loadScript = (src) => {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', resolve);
                script.addEventListener('error', reject);
                document.body.appendChild(script);
            });
        };

        // Load the mobilenav.js script
        loadScript('./assets/js/mobilenav.js').catch((e) =>
            console.error('Error loading mobilenav.js:', e)
        );
    }, []);

    return (
        <ul className="nav navbar-nav">
            <li className={isActive("/") ? "active" : ""}>
                <NavLink to="/">Home</NavLink>
            </li>
            <li className={isActive("/about-us") ? "active" : ""}>
                <NavLink to="/about-us">About us</NavLink>
            </li>
            <li className={isActive("/projects") ? "active" : ""}>
                <NavLink to="/projects">Projects</NavLink>
            </li>
            <li className={isActive("/gallery") ? "active" : ""}>
                <NavLink to="/gallery">Gallery</NavLink>
            </li>
            <li className={isActive("/careers") ? "active" : ""}>
                <NavLink to="/careers">Careers</NavLink>
            </li>
            <li className={isActive("/contact-us") ? "active" : ""}>
                <NavLink to="/contact-us">Contact us</NavLink>
            </li>
        </ul>
    );
};

export default Navigation;
